export function isObject(o: any): boolean {
  return Object.prototype.toString.call(o) === '[object Object]';
}

export function isArray(a: any): boolean {
  return Object.prototype.toString.call(a) === '[object Array]';
}

export function isFunction(fn: any): boolean {
  return fn && typeof fn === 'function';
}

export function isStringSymbolUnion(key: any): boolean {
  return typeof key === 'string' || typeof key === 'symbol';
}

export function warn(message: string): void {
  return console && console.warn(message);
}
